import appGlobalScript from '/home/runner/work/calcite-design-system/calcite-design-system/packages/calcite-components/src/utils/globalScript.ts';
export const globalScripts = appGlobalScript;
